/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { TimePicker } from "antd";
import moment from "moment";

class TimepickerLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      timeString: "",
      stepTime: this.props.stepTime,
    };
  }
  componentDidMount() {
  
    let { slug } = this.props.match.params;
    if (slug === "edit") {
      this.setState((state) => ({ timeString: this.props.selectdata.value }));
      this.props.onselectChanges({
        id: this.props.selectdata.name,
        name: this.props.selectdata.name,
        value: this.props.selectdata.value,
        parrentMode: this.props.selectdata.parrentMode,
        parrentName: this.props.selectdata.parrentName,
      });
    }
  }
  onChange = (time, timeString) => {
    this.props.onselectChanges({
      id: this.props.selectdata.name,
      name: this.props.selectdata.name,
      value: timeString,
      parrentMode: this.props.selectdata.parrentMode,
      parrentName: this.props.selectdata.parrentName,
    });
  };
  render() {
   return (
      <TimePicker
        use12Hours
        format="h:mm a"
        minuteStep={this.state.stepTime ? this.state.stepTime : 15}
        className="w-100"
        defaultValue={
          this.props.selectdata.value
            ? moment(this.props.selectdata.value, "h:mm a")
            : null
        }
        onChange={this.onChange}
        placeholder={
          this.props.selectdata.label
            ? this.props.selectdata.label
            : this.props.selectdata.placeholder
        }
        disabled={this.props.selectdata.disable}
      />
    );
  }
}

export default TimepickerLayer;
